// decodes an encoded URI component value, returning undefined for undefined or null values
const getDecodedURIComponent = encodedValue => (encodedValue === undefined || encodedValue === null ? undefined : decodeURIComponent(encodedValue))

export default getDecodedURIComponent



// WEBPACK FOOTER //
// ./src/utilities/getDecodedURIComponent.js